import React, { Component } from 'react';
import { IntlProvider } from 'react-intl';
import { AppConsumer } from '../../contexts/app-context';

import messages_en from "../../translations/en.json";
import messages_et from "../../translations/et.json";
import messages_ru from "../../translations/ru.json";
import messages_lv from "../../translations/lv.json";
import messages_lt from "../../translations/lt.json";

const messages = {
    'en': messages_en,
    'et': messages_et,
    'ru': messages_ru,
    'lv': messages_lv,
    'lt': messages_lt
};

class ConnectedIntlProvider extends Component {
  constructor(props) {
    super(props);
    this.state = { counter: 0 };
  }
  render() {
    const { children } = this.props;
    return (
      <AppConsumer>
        {props => {
          const { locale, switchLanguage, setCorrectAnswers, finished, setFinished } = props;
          return (
            <IntlProvider finished={finished} setFinished={setFinished} locale={locale} switchLanguage={switchLanguage} setCorrectAnswers={setCorrectAnswers} messages={messages[locale]} >
              {children}
            </IntlProvider>
          )
        }}
      </AppConsumer>
    );
  }
}

export default ConnectedIntlProvider;
